export default __webpack_public_path__ + "static/media/righthand.297b9180.png";